import { createRouter } from 'vue-router'
import { createApp } from 'vue'
import { createWebHistory } from 'vue-router'
import App from './App.vue'
import routes from './router'
import mitt from 'mitt'
import { createI18n } from "vue-i18n";


// import translations
import de from "./locales/de.json";
import en from "./locales/en.json";
import nl from "./locales/nl.json";

// configure i18n
const i18n = createI18n({
  locale: "de",
  fallbackLocale: "de",
  messages: { de, en, nl },
});

function parseSettingsData(rawSettings) {
  if (!rawSettings) {
    return {};
  }

  const legacyJson = rawSettings.replace(/%30/g, '"');

  try {
    return JSON.parse(legacyJson);
  } catch (_legacyError) {
    // console.warn('Failed to parse legacy JSON. Attempting base64 decoding...');
  }

  try {
    const decodedBinary = window.atob(rawSettings);
    const decodedBytes = Uint8Array.from(decodedBinary, (character) => character.charCodeAt(0));
    const decodedJson = new TextDecoder().decode(decodedBytes);
    return JSON.parse(decodedJson);
  } catch (_base64Error) {
    throw new Error('Invalid data-settings payload. Expected legacy escaped JSON or base64-encoded JSON.');
  }
}

setTimeout(() => {
const vueEls = document.getElementsByClassName('entwickler-vue-app');



for (const vueEl of vueEls) {
  let router;
  const settingsData = parseSettingsData(vueEl.dataset.settings || '');
  router = createRouter({
    history: createWebHistory(settingsData.baseUrl),
    routes
  });

  // If isDevMioActive or isDevmioNlActive is true, set the locale to 'en'
  if (settingsData.isDevMioActive || settingsData.isDevmioNlActive) {
    i18n.global.locale = "en";
  }

  const emitter = mitt();

  const app = createApp(App,{ ...vueEl.dataset }).use(router);
  app.config.globalProperties.emitter = emitter;
  app.use(i18n);
  app.mount('#' + vueEl.id);
}


            
}, 500);

//useful links for apollo and Unit testing
//https://www.apollographql.com/blog/frontend/getting-started-with-vue-apollo/
//https://blog.canopas.com/vue-3-component-testing-with-jest-8b80a8a8946b

